<template>
  <div className="contact-page">
    <iframe
      :src="iframeSrc"
      frameborder="0"
    />
  </div>
</template>

<script>
import {useRoute} from 'vue-router/dist/vue-router'
import {computed, getCurrentInstance, onMounted, onUnmounted} from 'vue'

export default {
  name: 'ContactPage',
  setup() {
    const route = useRoute()
    const {companyData, iframeUrl} = getCurrentInstance().appContext.config.globalProperties

    const handleMessage = (event) => {
      if (event.origin === iframeUrl && event.data.type === 'open-personal-data-policy') {
        try {
          window.open('/privacy_policy.pdf', '_blank');
        } catch(e) {
          console.error('Возникла проблема с открытием файла privacy_policy.pdf')
        }
      }
    }

    const iframeSrc = computed(() => {
      const url = new URL(`${iframeUrl}/iframe/contacts/`)
      url.searchParams.append('color', `#${companyData.frameColor || companyData.color}`)
      url.searchParams.append('locationGuid', companyData.locationGuid)
      url.searchParams.append('locationSelector', `1`)
      Object.entries(route.query || {}).forEach(([key, value]) => {
        url.searchParams.set(key, value.toString())
      })
      return url.href
    })

    onMounted(() => {
      window.addEventListener('message', handleMessage);
    })

    onUnmounted(() => {
      window.removeEventListener('message', handleMessage);
    })

    return {
      iframeSrc
    }
  }
}
</script>

<style scoped>
.contact-page {
  background-color: #f9f9f9;
}

iframe {
  height: 900px;
  max-width: 100%;
  width: 100%;
}

@media screen and (max-width: 768px) {

}
</style>
